import { Component, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { environment } from '@env/environment';
import { FeatureFlagsService } from '../services/feature-flags.service';
import { PackageService } from '../services/package.service';
@Component({
  selector: 'app-appt-dtl-card',
  templateUrl: './appt-dtl-card.component.html',
  styleUrls: ['./appt-dtl-card.component.scss']
})
export class ApptDtlCardComponent {
  @Output() polciyExpireAction: EventEmitter<any>;
  @Input() flowType:any;
  @Input() showpolicyInfo:boolean;
  @Input() fromSlotBlockPrompt:boolean;
  @Input() apptInfo: any;
  @Input() scheduleCost: any;
  @Input() type: string;
  @Input() isReferralApplicable: boolean;
  @Input() refControl: any;
  @Output() editAction: EventEmitter<any>;
  @Output() complete: EventEmitter<any>;
  @Input() isEditApplicable: boolean;
  @Input() groupedServices: any;
  @Input() selectedPackage: any;
  public translateType = 'LOCALE';
  public currency_code: string;
  public linkWithoutRelation: boolean;
  public result: any = {
    "referralCode": ""
  };
  public enterReferral: boolean;
  public regexValidation: string = null;
  public isBookingSubService: boolean = false;
  public readonly footerApplicableStatus = ['A', 'C'];
  public showServiceIncludedModal: boolean = false;
  public selectedGrpService: any;
  public healthPkg: any;
  constructor(private user: UserService,  private featureService: FeatureFlagsService, private cdf: ChangeDetectorRef, private packageService: PackageService) {
    this.currency_code = this.user.getCurrency() || environment['CURRENCY'];
    this.editAction = new EventEmitter<any>();
    this.complete = new EventEmitter<any>();
    this.polciyExpireAction = new EventEmitter<any>();

  }

  ngOnInit(){
    this.healthPkg = this.packageService.getAllHpValues()
    console.log('isReferralApplicable', this.isReferralApplicable, 'groupedServices', this.groupedServices, 'apptInfo', this.apptInfo, 'type', this.type);
    this.linkWithoutRelation = this.featureService.featureOn('FT_APP_LINKWITHOUTRELATION');
    this.isBookingSubService = this.user?.getIsBookingSubService() || false;
    if(!this.isBookingSubService) {
      if(!this.apptInfo['appointmentType'] && this.apptInfo?.in?.home) {
        this.apptInfo['appointmentType'] = this.apptInfo?.in?.home?.visitType;
      }
    }
  }

  public onTextInput(ev?: any) {
    console.log('event',ev)
    let regexValidation = this.refControl.regex;
    if (regexValidation) {
      const regex = new RegExp(regexValidation, 'g')
      let value = ev.target.value;
      let newVal = value.replace(regex, '');
      ev.target.value = newVal;
      this.result.referralCode = newVal;
    }
  }

  public async showIncludedServices(services) {
    this.showServiceIncludedModal = true;
    this.selectedGrpService = services;
  }

  switchAction(type){
    this.editAction.emit(type);
  }

  competeAction(){
    this.complete.emit(this.result);
  }

  public removeReferral() {
    this.result.referralCode = ''
  }

  public openPolicyExpirePop(){
    this.polciyExpireAction.emit();
  }

  public openPackageDetail() {
    this.complete.emit(this.apptInfo)
  }
  
  public closeServiceModal() {
    this.showServiceIncludedModal = false;
  }
}
